import { Link } from "react-router-dom";
import { Mail, MapPin, Building2, Phone } from "lucide-react";

/**
 * Site footer — legal & company info. Used in landing, pricing and legal pages.
 */
export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-rule bg-paper-2/30"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-14">
          {/* Brand */}
          <div>
            <Link
              to="/"
              className="inline-flex items-baseline gap-0.5"
              data-testid="footer-brand"
            >
              <span className="font-serif italic text-3xl text-copper -mr-0.5">
                una
              </span>
              <span className="font-serif text-3xl tracking-tight text-ink">
                TESIS
              </span>
            </Link>
            <p className="mt-4 text-[13.5px] text-ink-soft leading-relaxed max-w-xs">
              El copiloto académico para sustentantes mexicanos. Redacción
              guiada, citas reales, plantillas universitarias y blindaje
              criptográfico de autoría.
            </p>
          </div>

          {/* Empresa */}
          <div data-testid="footer-company">
            <p className="text-[10px] tracking-[0.28em] uppercase text-copper font-medium">
              Quiénes somos
            </p>
            <ul className="mt-3 flex flex-col gap-3 text-[13px] text-ink leading-snug">
              <li className="flex items-start gap-2">
                <Building2 size={14} className="mt-0.5 text-forest shrink-0" />
                <span>
                  Marketing de Inteligencia Artificial S. de R.L. de C.V.
                </span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={14} className="mt-0.5 text-forest shrink-0" />
                <span>
                  Av. Américas 1545, pisos 20, 21, 22 y 23
                  <br />
                  Col. Providencia, Guadalajara, Jalisco, México
                </span>
              </li>
              <li className="flex items-start gap-2">
                <Mail size={14} className="mt-0.5 text-forest shrink-0" />
                <a
                  href="mailto:contacto@unatesis.com"
                  className="hover:text-forest transition-colors"
                >
                  contacto@unatesis.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <Phone size={14} className="mt-0.5 text-forest shrink-0" />
                <a
                  href="https://wa.me/523342802102?text=Hola%20unaTESIS%2C%20necesito%20apoyo%20con%20la%20plataforma."
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-phone"
                  className="hover:text-forest transition-colors"
                >
                  +52 33 4280 2102
                </a>
              </li>
            </ul>
          </div>

          {/* Legales */}
          <div data-testid="footer-legal">
            <p className="text-[10px] tracking-[0.28em] uppercase text-copper font-medium">
              Legal
            </p>
            <ul className="mt-3 flex flex-col gap-2.5 text-[13px] text-ink-soft">
              <li>
                <Link
                  to="/terminos"
                  data-testid="footer-terms"
                  className="hover:text-forest transition-colors"
                >
                  Términos del servicio
                </Link>
              </li>
              <li>
                <Link
                  to="/privacidad"
                  data-testid="footer-privacy"
                  className="hover:text-forest transition-colors"
                >
                  Aviso de privacidad
                </Link>
              </li>
              <li>
                <Link
                  to="/pricing"
                  className="hover:text-forest transition-colors"
                >
                  Precios
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-rule flex flex-col sm:flex-row sm:items-center justify-between gap-3">
          <p className="text-[11.5px] text-ink-soft">
            © {year} Marketing de Inteligencia Artificial S. de R.L. de C.V. ·
            Todos los derechos reservados.
          </p>
          <p className="text-[11px] text-ink-soft/80">
            Hecho con cuidado en Guadalajara, Jalisco · México.
          </p>
        </div>
      </div>
    </footer>
  );
}
